import type { Channel } from "@sobidogam/platform-ports";

export function navigate(path: string) {
	window.history.pushState({}, "", path);
	window.dispatchEvent(new PopStateEvent("popstate"));
	window.scrollTo({ top: 0, behavior: "smooth" });
}

export function Header({ channel }: { channel: Channel }) {
	const currentPath =
		typeof window === "undefined" ? "" : window.location.pathname;
	return (
		<header className="site-header">
			<a
				className="wordmark"
				href="/"
				onClick={(event) => {
					event.preventDefault();
					navigate("/");
				}}
			>
				<img className="wordmark-logo" src="/brand/logo.svg" alt="소비도감" />
			</a>
			<nav aria-label="주요 메뉴">
				<a
					href="/dogam"
					aria-current={
						currentPath === "/dogam" || currentPath.startsWith("/dogam/")
							? "page"
							: undefined
					}
					onClick={(event) => {
						event.preventDefault();
						navigate("/dogam");
					}}
				>
					도감
				</a>
				<a
					href="/release-notes"
					aria-current={currentPath === "/release-notes" ? "page" : undefined}
					onClick={(event) => {
						event.preventDefault();
						navigate("/release-notes");
					}}
				>
					업데이트
				</a>
				<a
					className="button button-small"
					href="/app"
					onClick={(event) => {
						event.preventDefault();
						navigate("/app");
					}}
				>
					{channel === "ait" ? "기록 시작" : "내 기록 열기"}
				</a>
			</nav>
		</header>
	);
}

export function SiteFooter() {
	return (
		<footer className="site-footer">
			<span>소비도감 · 소비를 표본으로</span>
			<span>
				<a
					href="/privacy"
					onClick={(event) => {
						event.preventDefault();
						navigate("/privacy");
					}}
				>
					개인정보
				</a>{" "}
				·{" "}
				<a
					href="/terms"
					onClick={(event) => {
						event.preventDefault();
						navigate("/terms");
					}}
				>
					약관
				</a>{" "}
				·{" "}
				<a
					href="/support"
					onClick={(event) => {
						event.preventDefault();
						navigate("/support");
					}}
				>
					문의
				</a>
			</span>
		</footer>
	);
}
